<template>
  <modal
    class="createAssetGroup"
    name="getAsset"
    transition="pop-out"
    :width="modalWidth"
    @opened="opened"
    @closed="closed"
  >
    <div>
      <h5 class="asset_modal_title text-center primary-color">
        {{ $t("text.assets.assetDetail") }}
      </h5>
      <div class="full__row_section mb-5">
        <div class="pos_modal">
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.assetN") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ assetDetails.name }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.assetGName") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ assetDetails.assetGroupName }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.assetDescription") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ assetDetails.description }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.assetStatus") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ assetDetails.formattedStatus }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.licenseNumber") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  assetDetails.assetLicenseNo !== "null"
                    ? assetDetails.assetLicenseNo
                    : "N/A"
                }}</label>
              </div>
            </div>
          </div>
          <div
            class="row align-items-center p-2"
            v-if="assetDetails.isServiceable"
          >
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.servDate") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  assetDetails.lastServiceDate
                    ? $moment(assetDetails.lastServiceDate).format(
                        "D MMMM, YYYY"
                      )
                    : "N/A"
                }}</label>
              </div>
            </div>
          </div>
          <div
            class="row align-items-center p-2"
            v-if="assetDetails.isRenewable"
          >
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.lastRenewalDate") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  assetDetails.lastRenewalDate
                    ? $moment(assetDetails.lastRenewalDate).format(
                        "D MMMM, YYYY"
                      )
                    : "N/A"
                }}</label>
              </div>
            </div>
          </div>

          <div
            class="row align-items-center p-2"
            v-if="assetDetails.expirationDate"
          >
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.expirationDate") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  assetDetails.expirationDate
                    ? $moment(assetDetails.expirationDate).format(
                        "D MMMM, YYYY"
                      )
                    : "N/A"
                }}</label>
              </div>
            </div>
          </div>

          <div
            class="row align-items-center p-2"
            v-if="assetDetails.expirationDate"
          >
            <div class="col-md-6 label_text">
              <label>{{ $t("text.assets.dateCreated") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  $moment(assetDetails.dateCreated).format("D MMMM, YYYY")
                }}</label>
              </div>
            </div>
          </div>
          <hr />
          <h6
            class="text-center mt-4 primary-color"
            v-if="assetDetails.assetFiles && assetDetails.assetFiles.length > 0"
          >
            {{ $t("text.assets.documents") }}
          </h6>
          <div class="row align-items-center p-3">
            <div
              class="col-md-3"
              v-for="(file, index) in assetDetails.assetFiles"
              :key="index"
            >
              <div>
                <img
                  :src="file.show ? file.url : customDocumentUrl"
                  width="100"
                  height="100"
                />
              </div>
              <div class="ml-4 mt-3">
                <i
                  class="fa fa-trash-o red-color cursor-pointer"
                  title="Delete"
                  aria-hidden="true"
                  @click="deleteAsset(file)"
                ></i>
                <i
                  class="fa fa-download ml-2 primary-color cursor-pointer"
                  title="Download"
                  aria-hidden="true"
                  @click="download(file.url)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "getAsset",
  props: ["id"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      modalDataValues: {},
      pumpName: "",
      assetDetails: {},
      assetStatus: "",
      downloadUrl: "",
      customDocumentUrl:
        "https://img.freepik.com/free-vector/illustration-document-icon_53876-28510.jpg?size=626&ext=jpg",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  mounted() {},

  methods: {
    showDocument(url) {
      const fileTypeIndex = url.lastIndexOf(".");
      const fileType = url.slice(fileTypeIndex + 1);
      if (fileType === "jpg" || fileType === "png" || fileType === "jpeg") {
        return true;
      } else {
        return false;
      }
    },
    download(url) {
      const fileTypeIndex = url.lastIndexOf(".");
      const fileType = url.slice(fileTypeIndex + 1);
      this.axios({
        url,
        method: "GET",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", fileType);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$toast.open({
            message: this.$t("text.assets.downloadSuccessful"),
            type: "success",
            duration: 3000,
          });
        })
        .catch((e) => {});
    },
    opened() {
      this.getAsset();
    },
    deleteAsset(file) {
      const deleteConfirm = confirm(
        "Are you sure you want to delete this file?"
      );
      if (deleteConfirm) {
        this.axios
          .delete(
            `${configObject.apiBaseUrl}/Assets/${file.id}/delete-asset-file`,
            configObject.authConfig()
          )
          .then(() => {
            this.$toast.open({
              message: this.$t("text.assets.fileDeleted"),
              type: "success",
              duration: 5000,
            });
            this.getAsset();
          })
          .catch((error) => {
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 5000,
            });
          });
      }
    },
    getAsset() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Assets/${this.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.assetFiles.forEach((file) => {
            file.show = this.showDocument(file.url);
          });
          res.data.formattedStatus =
            res.data.assetstatus == 0
              ? "Okay"
              : res.data.assetstatus == 1
              ? "Service Due"
              : res.data.assetstatus == 2
              ? "Renewal Due"
              : res.data.assetstatus == 3
              ? "Expired"
              : res.data.assetstatus == 4
              ? "Service due and expired"
              : "Renewal due and expired";
          this.assetDetails = res.data;
        })
        .catch((error) => {});
    },
    closed() {
      this.$eventHub.$emit("refreshBranchAssets");
    },
  },
};
</script>
